import { all, fork, put, takeEvery } from "redux-saga/effects";
// import { useIntl } from 'react-intl';
import {
    BOOKING_LOAD_BOOKING_LIST,
    BOOKING_LOAD_BOOKING_LISTS,
    BOOKING_LOAD_REVIEW,
    BOOKING_UPDATE_SHOW_REVIEW,
    BOOKING_LOAD_REVIEW_CHAT,
    BOOKING_SEND_REVIEW_CHAT_ADMIN,
    BOOKING_READ_REVIEW_CHAT,
    // BOOKING_LOAD_BOOKING_LIST_SUCCESS
} from "../actions";
import {
    bookingGetBooking,
    bookingGetBookings,
    bookingGetPaymentBookingbyYacht,
    bookingGetReview,
    bookingGetReviewChat,
    bookingUpdateShowReview,
    bookingSendReviewChatAdmin,
    bookingReadReviewChat,
} from "../../helpers/booking-api";
import { NotificationManager } from '../../components/common/react-notifications';
import {
    // getBooklist,
    getBooklistSuccess,
    getAllPaymentBookingSuccess,
    getReviewSuccess,
    getReviewChatSuccess,
    updateShowReviewSuccess,
    sendReviewChatAdminSuccess,
    readReviewChatSuccess,
} from "./actions";

// const intl = useIntl();
const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}
//  booking
function* bookingLoadBooklist({ payload, token }) {
    try {
        const dataRes = yield bookingGetBooking(payload, token);
        const dataResPaymentBooking = yield bookingGetPaymentBookingbyYacht(payload, token);
        if (dataRes.status === 'success' && dataResPaymentBooking.status === 'success') {
            yield put(getBooklistSuccess(dataRes.data));
            yield put(getAllPaymentBookingSuccess(dataResPaymentBooking.data));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* bookingLoadBooklists({ payload, token }) {
    try {
        const dataRes = yield bookingGetBookings(payload, token);
        const dataResPaymentBooking = yield bookingGetPaymentBookingbyYacht(payload, token);
        if (dataRes.status === 'success' && dataResPaymentBooking.status === 'success') {
            yield put(getBooklistSuccess(dataRes.data));
            yield put(getAllPaymentBookingSuccess(dataResPaymentBooking.data));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* bookingLoadReview({ payload, token }) {
    try {
        const dataRes = yield bookingGetReview(payload, token);

        if (dataRes.status === 'success') {
            yield put(getReviewSuccess(dataRes.data));
        } else if (
            dataRes.status === 'error' &&
            dataRes.auth === false
        ) {
            yield PullNotificationManager(
                "TIME OUT! Please Login again."
            );
        } else {
            yield PullNotificationManager(
                "Please wait about 30s and refresh your browser again."
            );
        }
    } catch (error) {
        yield PullNotificationManager(
            "Please wait about 30s and refresh your browser again."
        );
    }
}

function* bookingUpdateReviewShow({ payload, token }) {
    try {
        const dataRes = yield bookingUpdateShowReview(payload, token);

        if (dataRes.status === "success") {
            // แจ้งว่าอัปเดตสำเร็จ
            yield put(updateShowReviewSuccess(payload));

            // โหลด Review ใหม่
            // yield put(getReviewSuccess({}, token));
        } else if (
            dataRes.status === "error" &&
            dataRes.auth === false
        ) {
            yield PullNotificationManager(
                "TIME OUT! Please Login again."
            );
        } else {
            yield PullNotificationManager(
                "Update show review failed."
            );
        }
    } catch (error) {
        yield PullNotificationManager(
            "Please wait about 30s and refresh your browser again."
        );
    }
}

function* bookingLoadReviewChat({ payload, token }) {
    try {
        const dataRes = yield bookingGetReviewChat(payload, token);

        if (dataRes.status === "success") {
            yield put(getReviewChatSuccess(dataRes.data));
        } else if (
            dataRes.status === "error" &&
            dataRes.auth === false
        ) {
            yield PullNotificationManager(
                "TIME OUT! Please Login again."
            );
        } else {
            yield PullNotificationManager(
                "Please wait about 30s and refresh your browser again."
            );
        }
    } catch (error) {
        yield PullNotificationManager(
            "Please wait about 30s and refresh your browser again."
        );
    }
}

function* bookingSendReviewChatAdminSaga({ payload, token }) {

    try {

        const dataRes = yield bookingSendReviewChatAdmin(
            payload,
            token
        );


        if (dataRes.status === "success") {

            yield put(
                sendReviewChatAdminSuccess(dataRes)
            );


            // reload chat หลังส่งสำเร็จ
            yield put({
                type: BOOKING_LOAD_REVIEW_CHAT,
                payload: {
                    id_review: payload.id_review
                },
                token
            });


        } else if (
            dataRes.status === "error" &&
            dataRes.auth === false
        ) {

            yield PullNotificationManager(
                "TIME OUT! Please Login again."
            );

        } else {

            yield PullNotificationManager(
                "Send chat failed."
            );

        }


    } catch (error) {

        yield PullNotificationManager(
            "Please wait about 30s and refresh your browser again."
        );

    }
}

function* bookingReadReviewChatSaga({ payload, token }) {
    try {
        const dataRes = yield bookingReadReviewChat(
            payload,
            token
        );

        if (dataRes.status === "success") {

            yield put(
                readReviewChatSuccess(dataRes)
            );

        } else if (
            dataRes.status === "error" &&
            dataRes.auth === false
        ) {

            yield PullNotificationManager(
                "TIME OUT! Please Login again."
            );

        } else {

            yield PullNotificationManager(
                "Update read failed."
            );

        }

    } catch (error) {

        yield PullNotificationManager(
            "Please wait about 30s and refresh your browser again."
        );

    }
}

// Booklist
export function* watchLoadBooklist() {
    yield takeEvery(
        BOOKING_LOAD_BOOKING_LIST,
        bookingLoadBooklist
    );
}

export function* watchLoadBooklists() {
    yield takeEvery(
        BOOKING_LOAD_BOOKING_LISTS,
        bookingLoadBooklists
    );
}

export function* watchLoadReview() {
    yield takeEvery(
        BOOKING_LOAD_REVIEW,
        bookingLoadReview
    );
}


export function* watchUpdateShowReview() {
    yield takeEvery(
        BOOKING_UPDATE_SHOW_REVIEW,
        bookingUpdateReviewShow
    );
}

export function* watchLoadReviewChat() {
    yield takeEvery(
        BOOKING_LOAD_REVIEW_CHAT,
        bookingLoadReviewChat
    );
}

export function* watchSendReviewChatAdmin() {

    yield takeEvery(
        BOOKING_SEND_REVIEW_CHAT_ADMIN,
        bookingSendReviewChatAdminSaga
    );

}

export function* watchReadReviewChat() {

    yield takeEvery(
        BOOKING_READ_REVIEW_CHAT,
        bookingReadReviewChatSaga
    );

}

export default function* rootSaga() {
    yield all([
        //  Book list
        fork(watchLoadBooklist),
        fork(watchLoadBooklists),
        fork(watchLoadReview),
        fork(watchUpdateShowReview),
        fork(watchLoadReviewChat),
        fork(watchSendReviewChatAdmin),
        fork(watchReadReviewChat),
    ])
}